// config.js

const bizIcon = 'https://mybizsolutions.us/static/media/icon-app-logo.83ff8bf39a11df9fb7ac.jpg';
const myBizIcon = 'https://mybizsolutions.us/static/media/icon-app-logo.83ff8bf39a11df9fb7ac.jpg';
const imageOne = "https://media.istockphoto.com/id/124592761/photo/gardener.jpg?s=612x612&w=0&k=20&c=4PHreZcu_vu4y5VDBRoNdbSZXApVtz0FH3dlXnlQrDw=";
const imageTwo = "https://media.istockphoto.com/id/1989065703/photo/man-unrolling-rolls-of-turf-natural-grass-for-a-landscaping.jpg?s=612x612&w=0&k=20&c=Mpv6sUXJ3wy8F6eJanzDJomrnYpGQtZ5Pqv0h1S-rVI=";
const imageThree = "https://media.istockphoto.com/id/1400795879/photo/picture-of-grass-aerator-on-the-green-lawn.jpg?s=612x612&w=0&k=20&c=zBQxhwhODsCb-ZseMGa3RrdMiT0p-nfE1YOyPwyf7gY=";
const imageFour = "https://media.istockphoto.com/id/1156537866/photo/man-gardening-background.jpg?s=612x612&w=0&k=20&c=jeicQ_pzTTpqNKKrzfQLqgAZ4fCHueN-QcpGYyKR_YY=";
const imageFive = "https://media.istockphoto.com/id/1321341770/photo/trimming-hedge-with-garden-scissors.jpg?s=612x612&w=0&k=20&c=XovjRoQGdlbqzwx8G3jxU9QFhCzP8X55zTkJZf-_Lws=";

const redirectLink = "https://www.anaccuratelawncarellc.com/";

export const siteConfig = {
  title: "An Accurate Lawn Care",
  metaDescription: "An Accurate Lawn Care",
  theme: {
    primaryColor: "green-600",
    secondaryColor: "gray-900",
    accentColor: "text-green-600"
  },
  logo: {
    src: bizIcon,
    alt: "An Accurate Lawn Care Icon",
  },
  navigation: [
    { name: "Services", sectionId: "services" },
    { name: "About", sectionId: "about" },
    { name: "Location", sectionId: "location" },
  ],
  businessDetails: {
    name: "An Accurate Lawn Care",
    headline: "Professional Landscaping Services in Charleston, SC",
    address: "Charleston, SC, USA",
    description: `
        An Accurate Lawn Care is your premier destination for professional landscaping services in Charleston, South Carolina. Our dedicated team specializes in transforming outdoor spaces into stunning, well-maintained environments that enhance the beauty and value of your property. Whether it's regular lawn care, intricate landscape design, or seasonal maintenance, we are committed to delivering reliable, high-quality services tailored to your unique needs. Experience the difference with An Accurate Lawn Care—where your outdoor spaces flourish.
    `,
  },
  images: {
    business: {
      src: imageOne,
      alt: "Professional Landscaping Services in Charleston, SC",
      width: 2432,
      height: 1442
    }
  },
  features: [
    {
        description: 
          "Enhance Your Curb Appeal: Create a welcoming and inviting home with a well-maintained lawn. Our professional lawn care services ensure your outdoor spaces make a lasting impression.",
    },
    {
        description: 
          "Transform Your Outdoor Space: From intricate landscaping designs to seasonal maintenance, we specialize in turning your outdoor area into a stunning oasis tailored to your vision.",
    },
    {
        description: 
          "Book with Charleston's Top Landscapers: Trust An Accurate Lawn Care for reliable, high-quality landscaping services. We bring expertise and dedication to every lawn care project, ensuring exceptional results.",
    },
  ],
  services: {
    sectionTitle: "Our Lawn Care Services",
    description: 
      "An Accurate Lawn Care specializes in creating and maintaining beautiful outdoor spaces for homes in Charleston, SC. From precise edging to vibrant flower planting, we offer a variety of services tailored to meet your lawn care needs. Trust our expert team to elevate your curb appeal and bring your vision to life.",
    callouts: [
        {
          name: 'Edging Service',
          description: 
            "Achieve clean, well-defined edges that enhance the appearance of your lawn and landscaping. Our edging service ensures a polished, professional look for your outdoor spaces.",
          imageSrc: imageTwo,
          imageAlt: 'Expert team performing edging service for a clean and polished lawn look.',
        },
        {
          name: 'Lawn Mowing',
          description: 
            "Keep your lawn healthy and pristine with our professional mowing services. We provide clean, even cuts to promote lush growth and maintain your lawn's beauty.",
          imageSrc: imageThree,
          imageAlt: 'Team mowing a residential lawn to maintain its neat and vibrant appearance.',
        },
        {
          name: 'Flower Planting',
          description: 
            "Bring color and life to your garden with our expert flower planting services. We help design and plant vibrant blooms to create a stunning, personalized outdoor space.",
          imageSrc: imageFour,
          imageAlt: 'Gardener planting flowers to enhance the aesthetics of a garden.',
        },
    ]
  },
  about: {
    sectionTitle: "About Us",
    description:   
      "Welcome to An Accurate Lawn Care, your premier destination for professional landscaping services in Charleston, SC. With a commitment to excellence and a passion for creating stunning outdoor spaces, we take pride in delivering personalized lawn care solutions that enhance your property's beauty and value. From precise lawn maintenance to creative landscaping, our dedicated team ensures every project exceeds expectations. Trust An Accurate Lawn Care to transform your outdoor space into a vibrant, inviting oasis you can enjoy year-round.",
    image: {
      src: imageFive,
      alt: "An Accurate Lawn Care team providing professional landscaping services in Charleston, SC.",
      width: 1200,
      height: 800,
    },
  },
  location: {
    sectionTitle: "Our Location",
    destinationAddress: "Charleston, SC, USA",
    googleMapsEmbedUrl: 
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3248.3818520656753!2d-79.94027368485612!3d32.77647478097282!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x88fe7a77007a4a0b%3A0xa7c4b232a20e1b4b!2sCharleston%2C%20SC%2C%20USA!5e0!3m2!1sen!2sus!4v1710407450828!5m2!1sen!2sus",
    subCategories: [
      { 
        name: 'Apple Maps', 
        url: 'https://maps.apple.com/?address=Charleston,%20SC,%20USA',
      },
      { 
        name: 'Bing Maps', 
        url: 'https://www.bing.com/maps?q=Charleston,+SC,+USA&FORM=HDRSC6',
      },
      { 
        name: 'Google Earth', 
        url: 'https://earth.google.com/web/search/Charleston,+SC,+USA/@32.776474,-79.940273,15a,814.57589625d,35y,0h,0t,0r',
      },
      { 
        name: 'Google Maps', 
        url: 'https://www.google.com/maps/place/Charleston,+SC,+USA/@32.776474,-79.940273,15z',
      },
    ],  
  },
  contact: {
    sectionTitle: "Get in Touch with An Accurate Lawn Care",
    description: 
      "Transform your outdoor spaces with the expert landscaping services of An Accurate Lawn Care in Charleston, SC. From lawn mowing to full landscape design, our skilled team is here to make your outdoor vision a reality. Contact us today for a free estimate or to schedule a service appointment. Let us help you achieve the perfect lawn and garden!",
    socialLinks: {
      facebook: redirectLink,     
      instagram: redirectLink,     
      twitter: redirectLink,     
      linkedin: redirectLink,     
      youtube: redirectLink,     
    },
    contactNumbers: [
      "Mobile: (843) 366-88204",
    ],
    logo: bizIcon,
    emailRecipient: "eugene_minnifield@yahoo.com"
  },
  footer: {
    bizSolutionsLogo: myBizIcon
  }
};


